import React from "react";
import { DA_FeatureHandler } from "../../../helpers/FeatureHandler.helper";
import { V1 } from "./v1/RelewiseCategoryV1.component";

const featureName = "blockPLPSiloHouses";
const versions = {
    v1: V1,
};

// eslint-disable-next-line unused-imports/no-unused-vars
export const DA_ProductRelewiseListSiloAndHouse = React.forwardRef(
    // eslint-disable-next-line unused-imports/no-unused-vars
    ({ version, ...props }: any, ref: any) => (
        <DA_FeatureHandler
            featureName={featureName}
            featureVersions={versions}
            version={version}
            {...props}
        />
    )
);

DA_ProductRelewiseListSiloAndHouse.displayName = "DA_ProductRelewiseListSiloAndHouse ";
